import { throwApiError } from "./error-handling-actions";
import { ObjectTypeEnumText } from "../models/ObjectTypeEnum";
import { locksApi, notificationsApi } from "../../../utils";
import { signalRMessagesActions } from "./signalRMessages-slice";


export const fetchToken = () => {
    return async (dispatch) => {
        notificationsApi.notificationsTokenGeneratePost((error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "generalTokenGeneratePost " + error.message, level: 1, component: "Support", line: 29 }))
            }
            else {
                dispatch(signalRMessagesActions.initToken(resdata))
            }
        })
    }
}

export const updateMessages = (message, lessonId, userFrom, studyGroupId) => {
    return async (dispatch) => {
        dispatch(signalRMessagesActions.addMessage({ lessonId, message, userFrom, studyGroupId }))
    }
}

export const updateMessageProperty = (givenControl) => {
    return async (dispatch) => {
        dispatch(signalRMessagesActions.updateMessage({ givenControl }));
    };
};

export const updateReadenMessage = (isRead) => {
    return async (dispatch) => {
        dispatch(signalRMessagesActions.updateReadMessage({ isRead }));
    };
};

export const sendMessageToTeam = async (token, message, userToSend, lessonId, user, studyGroupId, setMessage, messageData) => {
    let notificationMessage = {
        method: message,
        data: {
            lessonId: lessonId,
            user: user?.exidentifier,
            studyGroupId: studyGroupId
        }
    }
    notificationsApi.notificationsSendUserUserExternalIdPost(userToSend, { notificationMessage: notificationMessage }, (error, resdata, response) => {
        if (error) {
            console.log("error", error);
        }
        else {
            setMessage(messageData);
        }
    })
};

export const sendControlRequest = async (token, messageType, userToSend, lessonId, user, studyGroupId, setMessage, messageData, messages, dispatch) => {
    try {
        let myData = {
            studyGroupId: studyGroupId || messages[messages?.length - 1]?.studyGroupId,
            refObjectId: lessonId || messages[messages?.length - 1]?.lessonId,
            refObjectType: ObjectTypeEnumText.Lesson,
        };

        locksApi.locksUnLockPost({ lockUnLockInput: myData }, async (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({
                    userMessage: "locksUnLockPost", error: error, statusCode: response?.statusCode, message: "locksUnLockPost " + error.message, level: 2, component: "locksUnLockPost", line: 36,
                }));
            } else {
                let notificationMessage = {
                    method: messageType,
                    data: {
                        lessonId: lessonId || messages[messages?.length - 1]?.lessonId,
                        user: user?.exidentifier,
                        studyGroupId: studyGroupId || messages[messages?.length - 1]?.studyGroupId
                    }
                }

                notificationsApi.notificationsSendUserUserExternalIdPost(userToSend ? userToSend : user.exidentifier, { notificationMessage: notificationMessage }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: "send message top notification", error: error, statusCode: response?.statusCode, message: "notificationsSendUserUserExternalIdPost " + error.message, level: 2, component: "", line: 36 }))
                    }
                    else {
                    }
                })
                setMessage(messageData);
            }
        });
    } catch (error) {
        console.error('Failed to send control request:', error);
    }
};
